import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=605a3690&scoped=true"
import script from "./DataSource.vue?vue&type=script&lang=js"
export * from "./DataSource.vue?vue&type=script&lang=js"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=605a3690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a3690",
  null
  
)

export default component.exports